import React from 'react';
import './Instruction.scss';

export function Instruction({ number, title, description }: InstructionProps) {
  return (
    <article className="instruction">
      <div className="instruction-title-bar">
        <div className="instruction-number">{number}</div>
        <h2 className="instruction-title">{title}</h2>
      </div>
      <p className="instruction-description">{description}</p>
    </article>
  );
}

export type InstructionProps = {
  number: number;
  title: React.ReactNode;
  description: React.ReactNode;
};
